export default __webpack_public_path__ + "static/media/tcmd_white.3293d85e.png";